var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBasicArrowDown = function SvgBasicArrowDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A3847",
    fillRule: "evenodd",
    d: "M10.884 6.19 8 9.085 5.115 6.19A.65.65 0 0 0 4.652 6a.65.65 0 0 0-.462.19.663.663 0 0 0 0 .929l3.347 3.356a.65.65 0 0 0 .925 0l3.347-3.356a.66.66 0 0 0 0-.928.653.653 0 0 0-.925-.001"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBasicArrowDown);
export default ForwardRef;